import React, { FC } from 'react'

import { ReactComponent as Logo } from '@assets/images/logo.svg'
import { IAppLogo } from '@interfaces/components/atoms/AppLogo'

const AppLogo: FC<IAppLogo> = ({ className, textClassName, withoutText, size }) => {
  return (
    <div className={`d-flex align-items-center ${className}`}>
      <Logo style={{ width: size, height: size }} />
      {!withoutText ? <div className={`ms-2 title-font ${textClassName}`}>uMore</div> : null}
    </div>
  )
}

export default AppLogo
